import { Injectable } from '@angular/core';
import { environment } from "src/environments/environment";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { NotificationService } from 'src/app/signalr/notification.service';
import { FeaBaseProcessService } from './fea-base-process.service';
import { firstValueFrom } from 'rxjs';
import { FatigueResultViewModel } from '../../models/results/fatigue-result.model';

@Injectable({
  providedIn: 'root'
})
export class FeaFatigueService {

  constructor(
    private readonly feaBaseProcessService : FeaBaseProcessService,
    private readonly http: HttpClient,
    private readonly notificationService: NotificationService,
  ) {
  }

  public async getResult(assetId?: string) : Promise<FatigueResultViewModel | null> {
    const baseRequest = await this.feaBaseProcessService.getBaseProcessRequest();
    const request = {
      ...baseRequest
    };

    if (assetId) {
      request.AssetId = assetId;
    }

    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Expires': '0'
      }),
      responseType: 'json' as 'json'
    };

    try {
      const resultData = await firstValueFrom(this.http.post<FatigueResultViewModel>(environment.API_FEA + `Fatigue/GetResult`, request, options));
      return resultData;
    }
    catch (err) {
      console.log(err);
      this.notificationService.addFailedNotification("Failed to get or parse Fatigue result");
      return null;
    }
  }
}

